<template>
  <div>
    <div class="head_img">
      <img :src="imge" alt @click="OpenUrl" />
    </div>
    <!-- {{this.scroheight}} -->
    <div
      class="search"
      ref="searchHeight"
      :class="{searchState:tabbarState === true}"
      id="toolbar"
      style="background:linear-gradient(top,#000,#fff);"
    >
      <div class="search_icon" @click="jump">
        <i class="fa fa-search" aria-hidden="true"></i>
        <span class="search_text">肛爆</span>
      </div>
      <div class="home-tab-icon">
        <img :src="alarmClock" alt @click="notice" />
        <img :src="write" style="margin-left:0.5rem" alt @click="addContent" />
      </div>
    </div>
    <div
      class="middle"
      id="header"
      :class="isFixed== true?'isFixed':''"
      :style="{opacityStyle:isFixed==true}"
    >
      <div class="middle_nav">
        <div
          v-for="(item,index) in middleList"
          :key="index"
          :class="{divstate:index === middleState}"
          @click="addgo(index)"
        >{{item}}</div>
      </div>
    </div>

    <!-- 动态 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="(homeitem,homeindex) in homeList" :key="homeindex">
        <div class="details">
          <div>
            <!-- 头像 -->
            <div class="details_box">
              <div class="details_box_left">
                <div class="details_user_logo" @click="myPost(homeitem)">
                  <!-- <img :src="homeitem.user.photo" art> -->
                  <img
                    v-if="homeitem.user.photo == null || homeitem.user.photo == 0"
                    src="../../../assets/images/ic_avatar_default.png"
                    alt
                  />
                  <img v-else :src="homeitem.user.photo" alt />
                  <img
                    v-if="homeitem.user.is_vip == 1"
                    class="img_logo"
                    src="../../../assets/medal/vip.png"
                    alt
                  />
                </div>
                <div class="details_user_data">
                  <div class="user_data_top">
                    <div class="user_data_top_name">{{homeitem.user.nickname}}</div>
                    <div class="user_data_top_logo" v-if="homeitem.id">
                      <img v-if="homeitem.user.sex == 1" src="../../../assets/icon/my/male.png" alt />
                      <img v-if="homeitem.user.sex == 2" src="../../../assets/icon/my/sex.png" alt />
                      <img
                        v-if="homeitem.user.sex == null || homeitem.user.sex == 0"
                        src="../../../assets/icon/my/sex.png"
                        alt
                      />
                    </div>
                  </div>
                  <div class="user_data_bottom">
                    <!-- 等级徽章 -->
                    <div class="user_data_bottom_logo" v-if="homeitem.user.invitees_num >= 50">
                      <img src="../../../assets/medal/medal_icon/of/50.png" alt />
                    </div>
                    <div
                      class="user_data_bottom_logo"
                      v-if="homeitem.user.invitees_num >= 30 && homeitem.user.invitees_num < 50"
                    >
                      <img src="../../../assets/medal/medal_icon/of/30-50.png" alt />
                    </div>
                    <div
                      class="user_data_bottom_logo"
                      v-if="homeitem.user.invitees_num >= 10 && homeitem.user.invitees_num < 30"
                    >
                      <img src="../../../assets/medal/medal_icon/of/10-30.png" alt />
                    </div>
                    <div
                      class="user_data_bottom_logo"
                      v-if="homeitem.user.invitees_num >= 3 && homeitem.user.invitees_num < 10"
                    >
                      <img src="../../../assets/medal/medal_icon/of/3-10.png" alt />
                    </div>
                    <div
                      class="user_data_bottom_logo"
                      v-if="homeitem.user.invitees_num >= 1 && homeitem.user.invitees_num < 3"
                    >
                      <img src="../../../assets/medal/medal_icon/of/1-3.png" alt />
                    </div>
                    <!-- 等级称号 -->
                    <div class="logo_box" v-if="homeitem.user.level != null">
                      <img
                        v-if="homeitem.user.level.id == 2"
                        src="../../../assets/medal/medal_icon/of/C.png"
                        alt
                      />
                      <img
                        v-if="homeitem.user.level.id == 3"
                        src="../../../assets/medal/medal_icon/of/B.png"
                        alt
                      />
                      <img
                        v-if="homeitem.user.level.id == 4"
                        src="../../../assets/medal/medal_icon/of/A.png"
                        alt
                      />
                      <img
                        v-if="homeitem.user.level.id == 5"
                        src="../../../assets/medal/medal_icon/of/ddd.png"
                        alt
                      />
                      <img
                        v-if="homeitem.user.level.id == 6"
                        src="../../../assets/medal/medal_icon/of/zz.png"
                        alt
                      />
                      <img
                        v-if="homeitem.user.level.id == 7"
                        src="../../../assets/medal/medal_icon/of/siji.png"
                        alt
                      />
                    </div>
                    <!-- 发帖称号 -->
                    <div
                      class="logo_box"
                      v-for="(medals,index) in homeitem.user.medals"
                      :key="index"
                    >
                      <img :src="medals.icon_1" alt />
                    </div>
                  </div>
                </div>
              </div>
              <div class="details_box_right" v-if="homeitem.cate_name">
                <div class="label">
                  <span>{{homeitem.cate_name}}#</span>
                </div>
              </div>
            </div>
            <div @click="gogo(homeitem.id)" v-if="homeitem.id">
              <div class="information">
                <div class="information_label" v-if="homeitem.tags">
                  <div v-if="homeitem.tags[0]== 1||homeitem.tags[1] == 1">热帖</div>
                  <div class="divState" v-if="homeitem.tags[0]==2|| homeitem.tags[1]==2">置顶</div>
                </div>
                <div class="information_message">{{homeitem.title}}</div>
              </div>
              <div class="text">{{homeitem.content}}</div>
              <div class="details_img">
                <div
                  class="details_img_box"
                  v-for="(images,index) in homeitem.images"
                  :key="index"
                  v-show="index < 3"
                >
                  <img v-lazy="images.image" alt />
                </div>
              </div>
              <p
                style="padding:0 2.5%;color:#cccccc;font-size:0.22rem;margin-top:0.12rem;color:#666"
              >{{homeitem.time}}</p>
            </div>
            <!-- 广告 -->
            <div v-else style="width:100%;">
              <img
                :src="homeitem.image"
                alt
                style="width:100%;border-radius: 5px;"
                @click="addopenurl(homeitem.ios_url)"
              />
            </div>
          </div>

          <div class="picture_icon">
            <div class="picture_icon_box">
              <div class="picture_icon_img" v-if="homeitem.id">
                <img src="../../../assets/myGive_icon/22.png" alt />
              </div>
              <span class="picture_icon_number" v-if="homeitem.id">{{homeitem.view | changeNumber}}</span>
              <span
                style="font-size:0.22rem;position: relative;left:0.05rem;color:#666;"
                v-else
              >{{homeitem.view | changeNumber}}次浏览</span>
            </div>
            <div class="picture_icon_box" v-if="homeitem.id">
              <div class="picture_icon_img">
                <img src="../../../assets/myGive_icon/66.png" alt />
              </div>
              <span class="picture_icon_number">{{homeitem.comments | changeNumber}}</span>
            </div>
            <div class="picture_icon_box" @click="praises(homeitem,homeindex)" v-if="homeitem.id">
              <div class="picture_icon_img">
                <img
                  v-if="homeitem.prictrueState == false"
                  src="../../../assets/myGive_icon/44.png"
                  alt
                />
                <img
                  v-if="homeitem.prictrueState == true"
                  src="../../../assets/myGive_icon/33.png"
                  alt
                />
              </div>
              <span
                class="picture_icon_number"
                v-if="homeitem.prictrueState == true"
              >{{homeitem.praises+1}}</span>
              <span
                class="picture_icon_number"
                v-if="homeitem.prictrueState == false"
              >{{homeitem.praises-1}}</span>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { home, praise, praiseDelete, check } from "../../../api/commonapi";
import secret from "../../../assets/js/utils";
import alarmClock from "../../../assets/icon/community/commutiy_icon/02.png";
import write from "../../../assets/icon/community/commutiy_icon/01.png";
export default {
  props: ["imge", "cate", "scroheight", "advertisingurl", "iosurl", "url"],
  data() {
    return {
      loading: false, //控制上拉加载的加载动画
      finished: false, //控制在页面往下移动到底部时是否调用接口获取数据
      alarmClock: alarmClock,
      write: write,
      middleList: ["日榜", "周榜", "月榜", "季榜", "年榜"],
      middleState: 0, //中间导航状态，也是类型
      tabbarState: false, //吸顶效果控制
      isFixed: false, //吸顶控制
      divState: false, //热帖标签
      page: 1, //页码
      homeList: [], //帖子列表
      opacityStyle: {
        top: 0
      }
    };
  },
  methods: {
    // 中间导航
    addgo(index) {
      this.middleState = index;
      this.page = 1;
      this.homeList = [];
      this.onLoad();
    },
    // 打开广告
    OpenUrl() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.open(this.iosurl);
      } else {
        window.open(this.url);
      }
    },
    // 列表加载
    onLoad() {
      setTimeout(() => {
        let params = {};
        params.page = this.page++;
        params.cate = this.cate;
        params.type = this.middleState + 1;
        let params_stringify = JSON.stringify(params);
        let params_Encrypt = secret.Encrypt(params_stringify);
        home({
          params: params_Encrypt
        }).then(res => {
          res = res.data;
          let res_data = secret.Decrypt(res);
          let data = JSON.parse(res_data);
          console.log(data);
          let list = data.data.map(val => {
            return {
              prictrueState: false,
              ...val
            };
          });
          // console.log(data)
          if ((data.code = 1)) {
            if (data.data == null) {
              this.finished = true;
              this.loading = false;
              return;
            } else {
              this.homeList = [...this.homeList, ...list];
              this.loading = false;
              // console.log(this.homeList);
            }
          } else {
            if (data.data == null) {
              this.finished = true;
              this.loading = false;
              return;
            }
          }
        });
      }, 1000);
    },
    //点赞
    praises(homeitem, index) {
      let params = {};
      params.user_id = JSON.parse(sessionStorage.getItem("userData")).id;
      params.type = 1;
      params.target = homeitem.id;
      let params_stringify = JSON.stringify(params);
      let params_Encrypt = secret.Encrypt(params_stringify);
      if (this.imgstate == false) {
        praise({
          params: params_Encrypt
        }).then(res => {
          res = res.data;
          let res_data = secret.Decrypt(res);
          let data = JSON.parse(res_data);
          if ((data.code = 1)) {
            this.imgstate = true;
            homeitem.prictrueState = true;
            this.$toast("点赞成功");
          }
        });
      } else {
        praiseDelete({
          params: params_Encrypt
        }).then(res => {
          res = res.data;
          let res_data = secret.Decrypt(res);
          let data = JSON.parse(res_data);
          if ((data.code = 1)) {
            this.imgstate = false;
            homeitem.prictrueState = false;
            this.$toast("取消成功");
          }
        });
      }
    },
    // 吸顶效果
    handleScroll() {
      this.$nextTick(() => {
        let scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let headerTop = document.getElementById("header");
        if (scrollTop > 175) {
          this.isFixed = true;
          this.tabbarState = true;
        } else {
          this.isFixed = false;
          this.tabbarState = false;
        }
      });
    },
    // 跳转到搜索
    jump() {
      this.$router.push("/commsearch");
    },
    // 跳到公告
    notice() {
      if (sessionStorage.getItem("userData")) {
        this.$router.push("/information");
      } else {
        this.$router.push("./login");
      }
    },
    // 跳到详情页
    gogo(id) {
      this.$router.push({
        path: "./checkTheDetails",
        query: { postID: id }
      });
      // this.$router.push("./checkTheDetails");
      // sessionStorage.setItem("homeitem", JSON.stringify(item));
    },
    // 跳到帖子发表
    addContent() {
      if (sessionStorage.getItem("userData")) {
        this.$router.push("/content");
      } else {
        this.$router.push("./login");
      }
    },
    //跳转到用户发帖列表
    myPost(item) {
      if (item.user.id) {
        if (sessionStorage.getItem("userData")) {
          this.$router.push({
            path: "./myPost",
            query: { id: item.user.id }
          });
        } else {
          this.$toast("请先登录");
        }
      } else {
        window.open(item.url);
      }
    },
    // 打开广告链接
    addopenurl(url) {
      window.open(url);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.opacityStyle.top =
      this.$refs.searchHeight.offsetHeight + Number(this.scroheight) + "px";
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {}
};
</script>

<style scoped lang="less">
.head_img {
  width: 100%;
  height: 4rem;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.search {
  width: 100%;
  height: 45px;
  position: fixed;
  top: 44px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .search_icon {
    margin: 0 0 0 0.55rem;
    width: 50%;
    height: 0.54rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    background: #6666;
    // opacity : 0.7;
    i {
      color: #ffffff;
      margin-left: 0.3rem;
      font-size: 0.24rem;
    }
  }
  .search_text {
    margin-left: 10px;
    color: #d6d4d4;
    font-size: 0.25rem;
  }
  .home-tab-icon {
    margin-right: 10px;
    img {
      width: 0.55rem;
      height: 0.55rem;
    }
  }
}
.searchState {
  width: 100%;
  height: 0.8rem;
  position: fixed;
  top: 44px;
  z-index: 999;
  display: flex;
  align-items: center;
  background: #ffffff;
  .search_icon {
    background: #eeeded;
  }
}
.isFixed {
  position: fixed;
  top: 75px;
  z-index: 4;
  width: 100%;
  background: #ffffff;
}
.middle {
  width: 100%;
  height: 1rem;
  margin-top: 0.1rem;
  background: #fff;
  display: flex;
  align-items: center;
  .middle_nav {
    width: 95%;
    height: 0.7rem;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #ff4444;
    border-radius: 25px;
    div {
      width: 2.1rem;
      height: 0.7rem;
      color: #ff4444;
      border-radius: 25px;
      line-height: 0.7rem;
      text-align: center;
    }
    .divstate {
      color: #ffffff;
      background: #f97a72;
    }
  }
}
.details {
  width: 100%;
  padding: 0 2.5%;
  margin: auto;
  margin-top: 0.2rem;
  border-bottom: 5px solid #f8f8f8;
  .details_box {
    width: 100%;
    height: 1.15rem;
    display: flex;
    .details_box_left {
      width: 77%;
      height: 100%;
      display: flex;
      // justify-content: space-between;
      .details_user_logo {
        position: relative;
        width: 1rem;
        height: 1rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50px;
          object-fit: cover;
        }
        .img_logo {
          // width: 70%;
          width: 0.75rem;
          height: 0.35rem;
          position: absolute;
          top: -0.2rem;
          left: 10%;
        }
      }
      .details_user_data {
        width: 3.7rem;
        height: 100%;
        margin-left: 0.1rem;
        display: flex;
        flex-wrap: wrap;
        .user_data_top {
          width: 100%;
          height: 50%;
          display: flex;
          align-items: center;
          .user_data_top_name {
            font-size: 0.27rem;
            font-weight: bold;
          }
          .user_data_top_logo {
            width: 0.28rem;
            height: 0.28rem;
            margin-left: 0.15rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .user_data_bottom {
          width: 100%;
          height: 50%;
          display: flex;
          .user_data_bottom_logo {
            width: 0.3rem;
            height: 0.35rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .logo_box {
            width: 0.75rem;
            height: 0.35rem;
            margin-left: 0.06rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .details_box_right {
      // width: 2rem;
      height: 100%;
      display: flex;
      flex-direction: row-reverse;
      .label {
        height: 20px;
        padding: 0 10px !important;
        border-radius: 5px;
        background: #fee7e6;
        line-height: 20px;
        span {
          font-size: 0.2rem;
          color: #ff4444;
          letter-spacing: 1px;
        }
      }
    }
  }
  .information {
    width: 100%;
    height: 0.5rem;
    display: flex;
    align-items: center;
    .information_label {
      // width: 20%;
      height: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        width: 0.6rem;
        height: 0.31rem;
        font-size: 0.2rem;
        text-align: center;
        line-height: 0.36rem;
        color: #ffffff;
        background: #fed330;
        border-radius: 5px;
      }
      .divState {
        background: #f97a72;
      }
    }
    .information_message {
      width: 90%;
      height: 100%;
      margin-left: 0.1rem;
      font-size: 0.25rem;
      line-height: 0.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .text {
    padding: 0 1.5%;
    margin-top: 0.1rem;
    font-size: 0.25rem;
    line-height: 18px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
  }
  .details_img {
    width: 100%;
    // height: 2.3rem;
    // margin-top: 0.2rem;
    display: flex;
    // flex-wrap: wrap;
    // justify-content: space-around;
    .details_img_box {
      width: 2.5rem;
      height: 2.5rem;
      img {
        width: 100%;
        height: 100%;
        padding: 0.1rem;
        border-radius: 10px;
        object-fit: cover;
      }
    }
  }
  .picture_icon {
    width: 95%;
    height: 0.6rem;
    margin: auto;
    margin-top: 0.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666;
    .picture_icon_box {
      display: flex;
      align-items: center;
      height: 0.5rem;
      .picture_icon_img {
        margin-top: 0.07rem;
      }
      .picture_icon_number {
        margin-left: 0.15rem;
        font-size: 0.23rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/community/como/hot.vue